export default __webpack_public_path__ + "static/team_spirit-520e756757017dfa974c11b975f3c043.svg";